import React from 'react';
import PropTypes from 'prop-types';
import './product-meta.scss';

const {
  advancedCommerce: { isListingPage },
} = window.inlineGlobalConfig;

const productData = ({ product }) => (
  <div className="product-meta__container">
    <div className="product-meta__wrapper">
      {!isListingPage && (
        <>
          <span className="product-meta__title" dangerouslySetInnerHTML={{ __html: product.name }} />{' '}
        </>
      )}
      <span className="product-meta__name" dangerouslySetInnerHTML={{ __html: product.description }} />
    </div>
    {product.markdown ? (
      <div className="product-meta__prices-wrapper">
        <span className="product-meta__was-price">{product.wasPrice}</span>
        <span className="product-meta__now-price">{product.price}</span>
      </div>
    ) : (
      <div className="product-meta__price">{product.price}</div>
    )}
  </div>
);

productData.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.any,
    product: PropTypes.bool,
  }).isRequired,
};

export default productData;
